/**
 * Test if the code is running on the client.
 *
 * @returns A boolean indicating if the code is running on the client.
 */
export const isClient = () => typeof document !== 'undefined';

/**
 * Test if the code is running on the server.
 *
 * @returns A boolean indicating if the code is running on the server.
 */
export const isServer = () => !isClient();
